import { Directive, TemplateRef } from '@angular/core';

interface Context<T> {
  $implicit?: T; // current item exposed as implicit value
  index?: number;
}

@Directive({
  selector: '[appCollapseRow]',
  standalone: false,
})
export class CollapseRowDirective {
  constructor(public templateRef: TemplateRef<any>) {}

  static ngTemplateContextGuard<T>(
    dir: CollapseRowDirective,

    ctx: any,
  ): ctx is Context<T> {
    return true;
  }
}
